export const EMPTY_STRING = '--';
